import loadable from '@loadable/component';

export const LoadableVerifyEmailDialogRoot = loadable(
  () =>
    import(
      /* webpackChunkName: "VerifyEmailDialogRoot" */ './VerifyEmailDialogRoot'
    ),
);
